import {
  STEP_CONFIGURE_WIDGET,
  STEP_CREATE_ORDER, STEP_RESULT,
  STEP_STATUS_CURRENT,
  STEP_STATUS_NEXT,
  STEP_STATUS_READY,
  STEP_SETUP_ENVIRONMENT
} from "./StepsContants";
import {STEP_ALLOW, STEP_DISALLOW, STEP_NEXT} from "./StepsActions";
import {APP_MODE_DOCUMENTATION, APP_MODE_QA} from "../app/AppConstants";
import {APP_MODE_SET} from "../app/AppActions";

const stepsList = {
  [APP_MODE_QA]: [
    {key: STEP_SETUP_ENVIRONMENT, value: 'Setup environment', number: 1, status: STEP_STATUS_CURRENT, isAllowed: true},
    {key: STEP_CREATE_ORDER, value: 'Create an Order', number: 2, status: STEP_STATUS_NEXT, isAllowed: false},
    {key: STEP_CONFIGURE_WIDGET, value: 'Configure the widget', number: 3, status: STEP_STATUS_NEXT, isAllowed: false},
    {key: STEP_RESULT, value: 'Result', number: 4, status: STEP_STATUS_NEXT, isAllowed: false}
  ],
  [APP_MODE_DOCUMENTATION]: [
    {key: STEP_CREATE_ORDER, value: 'Create an Order', number: 1, status: STEP_STATUS_CURRENT, isAllowed: true},
    {key: STEP_CONFIGURE_WIDGET, value: 'Configure the widget', number: 2, status: STEP_STATUS_NEXT, isAllowed: false},
    {key: STEP_RESULT, value: 'Result', number: 3, status: STEP_STATUS_NEXT, isAllowed: false}
  ]
}

const getStepsByMode = (mode) => {
  return stepsList[mode];
}

const getInitialState = () => {
  const defaultSteps = getStepsByMode(APP_MODE_QA);
  return {
    init: defaultSteps[0].key,
    list: defaultSteps
  }
}

export function steps(state = getInitialState(), action) {
  switch (action.type) {
    case APP_MODE_SET:
      let listSteps = getStepsByMode(action.value);
      return {
        ...state,
        init: listSteps[0].key,
        list: listSteps
      };
    case STEP_NEXT:
      let list = state.list;
      for (let value of list) {
        if (value.key === action.step) {
          value.status = STEP_STATUS_CURRENT;
        } else {
          value.status = STEP_STATUS_NEXT;
        }
      };
      for (let value of list) {
        if (value.status === STEP_STATUS_CURRENT) {
          break;
        } else {
          value.status = STEP_STATUS_READY;
        }
      }
      return {
        ...state,
        list
      };
    case STEP_ALLOW:
      let listAllow = state.list;
      for (let value of listAllow) {
        if (value.key === action.step) {
          value.isAllowed = true;
        }
      };
      return {
        ...state,
        list: listAllow
      };
    case STEP_DISALLOW:
      let listDisallow = state.list;
      for (let value of listDisallow) {
        if (value.key === action.step) {
          value.isAllowed = false;
        }
      };
      return {
        ...state,
        list: listDisallow
      };
    default:
      return state;
  }
}

export const getSteps = state => {
  return state.steps.list;
};

export const getCurrent = state => {
  return state.steps.list.find(step => step.status === STEP_STATUS_CURRENT);
};

export const getStepByKey = (state, key) => {
  return state.steps.list.find(step => step.key === key);
};

export const getNext = state => {
  const current = getCurrent(state);
  const index = getSteps(state).indexOf(current);
  if (getSteps(state).length === index+1) {
    return null;
  }
  return getSteps(state)[index+1];
};



// WEBPACK FOOTER //
// ./src/steps/StepsReducers.js